"use client";
import { Suspense, useState, useEffect } from "react";
import LoginNavigation from "@/app/components/elements/navigations/LoginNavigation";
import UserNavigation from "@/app/components/elements/navigations/UserNavigation";
import Search from "@/app/components/elements/forms/search/Search";
import Logo from "@/app/components/elements/Logo";
import FavoritesButton from "@/app/components/elements/buttons/FavoritesButton";
import CartNavigation from "@/app/components/elements/navigations/CartNavigation";
import { Button } from "@/app/components/shadcn/button";
import { Menu } from "lucide-react";
import useMobileNav from "@/app/hooks/useMobileNav";
import useAuth from "@/app/lib/features/auth/auth.hook";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const MainHeader = () => {
  const { onOpen } = useMobileNav();
  const { isAuthenticated, userProfile } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const showUserNav = mounted && isAuthenticated && userProfile;

  return (
    <div className="flex items-center justify-between gap-2 sm:gap-4 my-2">
      <div className="flex items-center gap-2">
        <Button
          onClick={() => { trackGeneric("mobile_menu_open", "click"); onOpen(); }}
          variant="outline"
          size="icon-sm"
          aria-label="Menüyü aç"
          className="flex items-center rounded-sm justify-center md:hidden"
        >
          <Menu size={20} />
        </Button>
        <Logo className="w-30 sm:w-40.75 xl:w-53.25" />
      </div>
      <div className="max-w-lg xl:max-w-xl w-full flex-1 hidden md:block">
        <Suspense fallback={null}>
          <Search />
        </Suspense>
      </div>
      <div className="flex items-center gap-4 xl:gap-6">
        {showUserNav ? <UserNavigation /> : <LoginNavigation />}
        <FavoritesButton />
        <CartNavigation />
      </div>
    </div>
  );
};

export default MainHeader;
